import {DashboardDao} from '../../../../dao';
import {DashboardConsultantProductionModel, ErrorModel} from '../../../../models';
import {DashboardConsultantProduction} from '../../../../models/dashboard/dashboardConsultantProduction';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'GET_ALL_DASHBOARD_CONSULTANT_PRODUCTION';

export async function getAllProductions(userData: Record<string, string>, params: string) {
    try {
        const result = await DashboardDao.ConsultantDao.ProductionDao.getAllProductions(userData.userToken, params);

        const parsedResult: DashboardConsultantProduction = DashboardConsultantProductionModel.parseDashboardConsultantProduction(result)

        // const addEditableBasedOnDate = (production: any) => {
        //     const productionYear = new Date(production.date).getFullYear();
        //     const currentYear = new Date().getFullYear();
        //     production.editable = productionYear === currentYear;
        // }

        // result.results.forEach(addEditableBasedOnDate);

        // return result;

        return parsedResult;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
